import { render, staticRenderFns } from "./TileLikertScore.vue?vue&type=template&id=05b7ecfc&scoped=true&"
import script from "./TileLikertScore.vue?vue&type=script&lang=ts&"
export * from "./TileLikertScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7ecfc",
  null
  
)

export default component.exports